/** @jsx jsx */
import { useState, useContext, Fragment } from 'react'
import { css, jsx } from '@emotion/core'
import { Button, Modal, Input } from '@livechat/design-system'

import { Context } from '../context'
import api from '../api'
import { VIEWS } from '../constants'

const SubmitModal = ({ name: initialName = '', survey, setIsOpen }) => {
  const { setSurveys, setView, surveyToken, setIsHintOpen } = useContext(
    Context
  )
  const [name, setName] = useState(initialName)
  const [error, setError] = useState(undefined)
  const [pending, setPending] = useState(false)

  const saveSurvey = async () => {
    if (name) {
      if (name.length < 100) {
        setError(undefined)
        setPending(true)

        const cleanedSurvye = survey.filter((field) => {
          const cleanedField = field

          if (!cleanedField.answers.length) {
            delete cleanedField.answers
          }

          return cleanedField
        })

        const status = await api.postSurvey(
          JSON.stringify(cleanedSurvye),
          name,
          surveyToken
        )

        if (status === 'OK') {
          const data = await api.getSurveys(surveyToken)
          setSurveys(data)
          setIsHintOpen(true)
          setView(VIEWS.SURVEYS)
        }
        setIsOpen(false)
        setPending(false)
      } else {
        setError('Survey name is too long.')
      }
    } else {
      setError('Please type the survey name.')
    }
  }

  const onEnterSubmit = (e) => {
    if (e.keyCode === 13) {
      saveSurvey()
    }
  }

  return (
    <Modal
      onClose={() => setIsOpen(false)}
      style={{ width: '600px', height: '300px' }}
      heading="Type the survey name"
      footer={
        <Fragment>
          <Button
            css={css`
              width: 130px;
              margin-right: 10px;
            `}
            size="large"
            onClick={() => setIsOpen(false)}
            secondary
          >
            Back
          </Button>
          <Button
            primary
            css={css`
              width: 130px;
            `}
            size="large"
            onClick={saveSurvey}
            loading={pending}
            data-cy="sandbox-survey-save-button"
          >
            Save
          </Button>
        </Fragment>
      }
    >
      <Input
        css={css`
          width: 100%;
          height: 40px;
        `}
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={onEnterSubmit}
        placeholder="Customer opinion survey"
        labelText="Input Field label"
        error={error}
        data-cy="sandbox-survey-name-input"
      />
      {error && (
        <span
          css={css`
            font-size: 12px;
            color: #d64646;
            margin-top: 5px;
          `}
        >
          {error}
        </span>
      )}

      <span
        className="desc"
        css={css`
          margin-top: 10px;
          margin-bottom: 5px;
          font-size: 13px;
        `}
      >
        Keep in mind that the name will be visible to your: <b>clients</b> and{' '}
        <b>agents</b>.
      </span>
    </Modal>
  )
}
export default SubmitModal
